import ChartBuilder from "../builders/history.chart.builder";

export default function GaugeChartDirector(data, routeName, chartTitle) {
  const chart = new ChartBuilder();
  const actualValueData = JSON.parse(data.actualValue.value).reverse();
  actualValueData.length = 3;
  const predictValue = JSON.parse(data.predictValue.value);
  const actualValue = actualValueData
    .map((item) => item.Actual_value_with_noise ?? item.Actual_value)
    .concat(Object.values(predictValue));
  const current = parseFloat(actualValue[0]);
  const [Prediction1, Prediction2] = Object.values(predictValue);
  const gaugeData = [current, Prediction1, Prediction2].map((i) =>
    Number(Number(i)?.toFixed(2))
  );
  const Average = Number(data.routeData.average) || 0;
  const chartMaxValue = Math.ceil(Math.max(Average, ...gaugeData) + (Average / 100) * 5)
  // Calculated the minimum value considering negative values
  const minValue = Math.floor(Math.min(0, Average, ...gaugeData) - (Average / 100) * 5);
  // // Adjust the minimum value by subtracting 10%
  const adjustedMinValue = Math.floor(minValue * 1.1);
  // Adjust the maximum value by adding 10%
  const adjustedMaxValue = Math.ceil(chartMaxValue * 1.1);
  let avg_year = '';
  const avgYear = data?.routeData?.avg_year;
  if (avgYear === null || avgYear === undefined) {
  } else if (avgYear === '') {
  } else {
    avg_year = `<br> <span style="font-weight:600;font-family:arial;font-size:12px;display:inline-block;margin-top:2px;"> Since ${data?.routeData?.avg_year} </span>`;
  }
  chart.setTitle(chartTitle || `${data.routeData.period} Gauge`, { margin: 20 });
  chart.setSubtitle(`${routeName} ${avg_year}`);
  chart.setOption({
    legend: {
      margin: 20,
    },
    chart: {
      type: "gauge",
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: "80%",
    },
  });

  chart.setOption({
    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ["50%", "75%"],
      size: "110%",
    },
  });

  chart.setExporting(true);
  chart.setOption({
    yAxis: {
      min: adjustedMinValue,
      max: adjustedMaxValue,

      minorTickInterval: "auto",
      minorTickWidth: 1,
      minorTickLength: 10,
      minorTickPosition: "inside",
      minorTickColor: "#666",

      tickPixelInterval: 30,
      tickWidth: 2,
      tickPosition: "inside",
      tickLength: 10,
      tickColor: "#666",
      labels: {
        step: 2,
        rotation: "auto",
      },
      title: {
        text: "Value",
      },
      plotBands: [
        {
          from: adjustedMinValue,
          to: ~~((chartMaxValue / 3) * 1),
          color: "#55BF3B", // green
        },
        {
          from: ~~((chartMaxValue / 3) * 1),
          to: ~~((chartMaxValue / 3) * 2),
          color: "#DDDF0D", // yellow
        },
        {
          from: ~~((chartMaxValue / 3) * 2),
          to: ~~((adjustedMaxValue / 3) * 3),
          color: "#DF5353", // red
        },
      ],
    },
  });
  chart.setOption({
    yAxis: {
      min: adjustedMinValue,
      max: adjustedMaxValue,
      tickPixelInterval: 72,
      tickPosition: "inside",
      tickColor: "#FFFFFF",
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: {
        distance: 20,
        style: {
          fontSize: "14px",
        },
      },
      lineWidth: 0,
      plotBands: [
        {
          from: adjustedMinValue,
          to: ~~((chartMaxValue / 3) * 1),
          color: "#55BF3B", // green
          thickness: 20,
        },
        {
          from: ~~((chartMaxValue / 3) * 1),
          to: ~~((chartMaxValue / 3) * 2),
          color: "#DDDF0D", // yellow
          thickness: 20,
        },
        {
          from: ~~((chartMaxValue / 3) * 2),
          to: adjustedMaxValue,
          color: "#DF5353", // red
          thickness: 20,
        },
      ],
    },
  });

  chart.setSeries(
    "Current Value",
    [current].map((i) => Number(Number(i).toFixed(2))),
    {
      visible: current !== -1,
      showInLegend: true,
      dial: {
        backgroundColor: "blue",
      },
    }
  );
  chart.setSeries(
    "Forecast Lead 1",
    [parseFloat(Prediction1)].map((i) => Number(Number(i).toFixed(2))),
    {
      visible: Prediction1 !== -1,
      showInLegend: true,
      dial: {
        backgroundColor: "black",
      },
    }
  );
  chart.setSeries(
    "Forecast Lead 2",
    [parseFloat(Prediction2)].map((i) => Number(Number(i).toFixed(2))),
    {
      visible: Prediction2 !== -1,
      showInLegend: true,
      dial: {
        backgroundColor: "green",
      },
    }
  );
  chart.setSeries(
    "Average Value",
    [parseFloat(Average)].map((i) => Number(Number(i).toFixed(2))),
    {
      visible: Average !== -1,
      showInLegend: true,
      dial: {
        backgroundColor: "orange",
      },
    }
  );

  return chart.build();
}
